import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const WORDS = [
  { text: "जनादेश.", hindi: true },
  { text: "elections.", hindi: false },
  { text: "brands.", hindi: false },
  { text: "narrative.", hindi: false },
];

export default function RotatingWord() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % WORDS.length), 2600);
    return () => clearInterval(t);
  }, []);
  const w = WORDS[i];
  return (
    <motion.span
      className="relative block h-[1.15em] overflow-visible"
      style={{ perspective: 600 }}
      data-testid="hero-rotating-word"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6, duration: 0.6 }}
    >
      <AnimatePresence mode="wait">
        <motion.span
          key={w.text}
          initial={{ y: "40%", opacity: 0, rotateX: -50 }}
          animate={{ y: 0, opacity: 1, rotateX: 0 }}
          exit={{ y: "-40%", opacity: 0, rotateX: 50 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className={`ribbon-text absolute left-0 top-0 block origin-bottom leading-[1.15] ${w.hindi ? "font-hindi normal-case tracking-normal" : "font-script normal-case italic tracking-normal"}`}
        >
          {w.text}
        </motion.span>
      </AnimatePresence>
    </motion.span>
  );
}
